import ReactFlipCard from "./ReactFlipCard";
export default ReactFlipCard;
